<mat-toolbar>
  Command Log
  <span style="flex: 1;"></span>
  <button mat-icon-button type="button" (click)="reload()" matTooltip="Refresh log">
    <mat-icon>refresh</mat-icon>
  </button>
</mat-toolbar>
<mat-progress-bar *ngIf="loading || loadingLastRun" mode="indeterminate"></mat-progress-bar>

<table class="dataTable">
  <thead>
  <tr>
    <th>Date</th>
    <th>Command Type</th>
    <th>Target</th>
    <th>
      <div class="vbox">
        Status
        <input [(ngModel)]="status" (ngModelChange)="filterChanged()" [ngModelOptions]="{standalone: true}" aria-label="Filter log status">
      </div>
    </th>
    <th>
      <div class="vbox">
        Error
        <input [(ngModel)]="error" (ngModelChange)="filterChanged()" [ngModelOptions]="{standalone: true}" aria-label="Filter log error">
      </div>
    </th>
  </tr>
  </thead>
  <tbody>
  <tr *ngFor="let log of logs">
    <td><a (click)="showLog(log.id, logDialog)">{{log.datetime | dateTime}}</a></td>
    <td>{{log.commandType}}</td>
    <td>{{log.targetName || '—'}}</td>
    <td [ngClass]="log.status === 'ERROR' || log.status === 'INTERRUPTED' ? 'CRITICAL' : ''">{{log.status}}</td>
    <td>{{log.error}}</td>
  </tr>
  <tr *ngIf="pageLoadError"><td colspan="5">Unable to load command log. Use Refresh to try again.</td></tr>
  <tr *ngIf="!loading && !pageLoadError && !logs.length"><td colspan="5">No log entries</td></tr>
  </tbody>
</table>
<mat-paginator (page)="reloadPage()" [pageSize]="5" [pageSizeOptions]="[5, 10, 20]"></mat-paginator>

<mat-toolbar>Last Run {{lastRun?.datetime | dateTime}}</mat-toolbar>
<div class="padded">
  <div *ngIf="lastRunLoadError">Unable to load Last Run. Use Refresh to try again.</div>
  <div *ngIf="!lastRun && !loadingLastRun && !lastRunLoadError">No runs logged yet</div>
  <ng-container *ngIf="lastRun">
    <table class="basicTable" style="width: 100%;">
      <tr>
        <td style="width: 100px; font-weight: bold;">Last Failure</td>
        <td>{{(lastFailure | dateTime) || '—'}}</td>
      </tr>
      <tr>
        <td style="width: 100px; font-weight: bold;">Last Success</td>
        <td>{{(lastSuccess | dateTime) || '—'}}</td>
      </tr>
    </table>
    <ng-container [ngTemplateOutlet]="runDetails" [ngTemplateOutletContext]="{$implicit: lastRun}"></ng-container>
  </ng-container>
</div>

<ng-template #logDialog let-log>
  <h1 mat-dialog-title>
    <button mat-icon-button type="button" mat-dialog-close matTooltip="Close window"><mat-icon>close</mat-icon></button>
    Command Run {{log.datetime | dateTime}}
  </h1>
  <mat-dialog-content>
    <ng-container [ngTemplateOutlet]="runDetails" [ngTemplateOutletContext]="{$implicit: log}"></ng-container>
    <table class="basicTable" style="width: 100%;">
      <tr><th>Command</th><td><pre class="mono">{{log.command}}</pre></td></tr>
      <tr><th>Command Args</th><td><pre class="mono">{{log.args | json}}</pre></td></tr>
      <tr><th>Variables</th><td><pre class="mono">{{log.vars | json}}</pre></td></tr>
      <tr><th>Transform</th><td>{{log.transform}}</td></tr>
      <tr><th>Transform Args</th><td><pre class="mono">{{log.transformArgs | json}}</pre></td></tr>
      <tr><th>Script</th><td><pre class="mono">{{log.script}}</pre></td></tr>
    </table>
  </mat-dialog-content>
</ng-template>

<ng-template #runDetails let-log>
  <table class="basicTable managed-command-results-table" style="width: 100%; table-layout: fixed;">
    <colgroup><col style="width: 100px;"><col></colgroup>
    <tbody>
    <tr>
      <td style="font-weight: bold;" [ngClass]="log.status === 'ERROR' || log.status === 'INTERRUPTED' ? 'CRITICAL' : ''">Status</td>
      <td>{{log.status}}</td>
    </tr>
    <tr><td style="font-weight: bold;">Target</td><td>{{log.targetName || '—'}}</td></tr>
    <tr>
      <td style="font-weight: bold;">Origin/User</td>
      <td>
        {{log.origin}}
        <ng-container *ngIf="log.runUserId">
          / <micro-user-lookup [userId]="log.runUserId"></micro-user-lookup>
        </ng-container>
      </td>
    </tr>
    <tr *ngIf="log.error">
      <td style="font-weight: bold;">Error</td>
      <td><textarea class="mono" style="width: 100%;" rows="5" readonly [value]="log.error"></textarea></td>
    </tr>
    <tr *ngIf="log.errorDetail">
      <td style="font-weight: bold;">Error Detail</td>
      <td><textarea class="mono" style="width: 100%;" rows="20" readonly [value]="log.errorDetail"></textarea></td>
    </tr>
    <tr>
      <td style="font-weight: bold;">Command Response</td>
      <td>
        <ng-container [ngTemplateOutlet]="responseContent" [ngTemplateOutletContext]="{$implicit: log.cmdRsp}"></ng-container>
      </td>
    </tr>
    <tr>
      <td style="font-weight: bold;">Script Response</td>
      <td>
        <ng-container [ngTemplateOutlet]="responseContent" [ngTemplateOutletContext]="{$implicit: log.scriptRsp}"></ng-container>
      </td>
    </tr>
    <tr>
      <td style="font-weight: bold;">Script Log</td>
      <td><textarea class="mono" style="width: 100%;" rows="10" readonly [value]="log.scriptLog || 'No script log'"></textarea></td>
    </tr>
    </tbody>
  </table>
</ng-template>

<ng-template #responseContent let-response>
  <div *ngIf="isStructured(response)" class="managed-command-json-viewer" tabindex="0">
    <ngx-json-viewer class="mono" [depth]="1" [json]="response"></ngx-json-viewer>
  </div>
  <textarea *ngIf="!isStructured(response) && response !== null && response !== undefined" class="mono" style="width: 100%;" rows="5" readonly [value]="response"></textarea>
  <span *ngIf="response === null || response === undefined" class="mono">Empty</span>
</ng-template>
